export function getOptionalNumber(value: number | string | null | undefined): number | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }

  const numberValue = Number(value);

  return Number.isFinite(numberValue) ? numberValue : undefined;
}

export function normalizeComparableString(value: unknown): string | null {
  return typeof value === 'string' && value.trim() ? value.trim().toLowerCase() : null;
}

/**
 * Strict integer parsing for numeric form inputs. `Number.parseInt` silently truncates decimals
 * ("1.5" -> 1) and accepts things a plain count shouldn't ("1e2" -> 1), while returning NaN for
 * benign in-progress typing like "-" or "". Number(...) + Number.isInteger rejects all of that
 * instead of coercing it, so invalid/incomplete input is treated the same as blank rather than
 * silently submitted as a different number.
 */
export function parseStrictInteger(raw: string, min: number): number | undefined {
  const trimmed = raw.trim();
  if (!trimmed) {
    return undefined;
  }
  const value = Number(trimmed);
  return Number.isInteger(value) && value >= min ? value : undefined;
}
